<div id="central-noticias" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent" 
            fxLayout="column" fxLayoutAlign="center center" 
            fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÃO -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
            <!-- APP TITLE -->
            <div class="logo" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    video_library
                </mat-icon>
                <span class="logo-text h1">
                    Central de Notícias
                </span>
                
                <!-- BOTÃO NOVA NOTÍCIA -->
                <button mat-mini-fab 
                        color="accent"
                        matTooltip="Nova Notícia"
                        (click)="openCadastro()"
                        style="margin-left: 16px;"
                        *ngIf="_authService.isPermissao(['Cadastrar Noticia'])">
                    <mat-icon>add_circle</mat-icon>
                </button>
            </div>
            </div>
        </div>

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="content p-24">

                <div fxLayout="column" fxLayoutAlign="center">
                    <div class="filters" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
                        fxLayoutAlign.gt-xs="space-between center">
                        <div class="noticia-search">
                            <mat-form-field appearance="outline" floatLabel="always" style="margin-right: 10px;">
                                <mat-label>De:</mat-label>
                                <input matInput [matDatepicker]="picker" (dateChange)="getAll()"
                                    [formControl]="data_noticia_inicio" name="data_noticia_inicio"
                                    placeholder="Data de Criação">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>À:</mat-label>
                                <input matInput [matDatepicker]="pickerFim" [formControl]="data_noticia_fim"
                                    (dateChange)="getAll()" name="data_noticia_fim" placeholder="Data de Criação">
                                <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
                                <mat-datepicker #pickerFim></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <mat-form-field class="category-selector" appearance="outline">
                            <mat-label>Categoria</mat-label>
                            <mat-select [formControl]="categoria_id" name="categoria_id" (selectionChange)="getAll()">
                                <mat-option value="">Todas</mat-option>
                                <mat-option *ngFor="let categoria of listCategorias" [value]="categoria.id">
                                    {{categoria.nome}}</mat-option>
                            </mat-select>
                            <mat-spinner diameter="20" *ngIf="loadingSpinnerCategoria"></mat-spinner>
                        </mat-form-field>
                    </div>

                    <!-- todo: verificar
                    [infiniteScrollDistance]="2" 
                        [infiniteScrollThrottle]="50" 
                        [infiniteScrollContainer]="'#container-3'" 
                        [fromRoot]="true" 
                    -->
                    <div 
                        infiniteScroll 
                        (scrolled)="onScroll()" 
                        *ngIf="!loadingSpinnerNoticias" 
                        class="noticias inner-scroll" 
                        fxLayout="row wrap"
                        fxLayoutAlign="center" 
                        [@animateStagger]="{value:'50'}"
                    >


                        <app-preview-noticia 
                            *ngFor="let noticia of filteredNoticias" 
                            fxFlex="100" 
                            fxFlex.gt-xs="50"
                            class="noticia" 
                            fxFlex.gt-sm="33" 
                            [@animate]="{value:'*',params:{y:'100%'}}"
                            [noticia]="noticia" 
                            (deleteNoticia)="removerDaLista($event)">
                        </app-preview-noticia>


                        <div class="no-noticias" *ngIf="filteredNoticias.length === 0">
                            Nenhum Registro Encontrado!
                        </div>

                        
                    </div>
                    <mat-spinner class="center" *ngIf="loadingSpinnerNoticias" diameter="200"></mat-spinner>
                </div>
            </div>
        </div>
    </div>
</div>